export interface CtaContent {
	title: string;
	subtitle: string;
}

export const ctaContent: CtaContent = {
	title: "{{year}} FOI APENAS O COMEÇO",
	subtitle: "Vamos fazer {{nextYear}} ainda mais épico juntos",
};
